import * as React from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';

import { useProjectsStore, useUiStore } from 'stores';
import MenuSection from 'shared/newComponents/MenuSection';
import { DocumentationIcon } from 'shared/newComponents/icons';
import { ComponentType } from 'shared/entities/components/Component';
import { DOCUMENTATION_LINK } from 'shared/entities/app';

import Sections from './Sections';
import CreateProjectButton from './CreateProjectButton';

import './Navigation.modules.scss';

type Props = {
  className?: string;
};

const Navigation: React.FC<Props> = ({ className }) => {
  const projectsStore = useProjectsStore();
  const uiStore = useUiStore();

  const hasProjects = !!projectsStore.projects.length;

  return (
    <div className={className}>
      <div
        styleName={cn(
          'navigation',
          !uiStore.menuState.opened && 'navigation_hidden'
        )}
      >
        <div styleName="navigation__top">
          {hasProjects ? (
            <Sections />
          ) : (
            <CreateProjectButton collapsed={!uiStore.menuState.opened} />
          )}
        </div>
        <div styleName="navigation__documentation">
          <MenuSection
            isImportant={true}
            hidden={!uiStore.menuState.opened}
            Icon={DocumentationIcon}
            title={(t) =>
              t('PageTemplate.Sections.documentation', {
                ns: 'newComponents'
              })
            }
            action={{
              type: ComponentType.a,
              href: DOCUMENTATION_LINK
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default observer(Navigation);
